import React from "react";
import IntegrationContainer from "../containers/IntegrationContainer";

function Integration() {
  return <IntegrationContainer></IntegrationContainer>;
}

export default Integration;
